<template>
  <div class="content">
    <grid-view v-if="gridView" :cases="caseFilter" :items="itemFilter" :type="type"></grid-view>
    <list-view v-else :cases="caseFilter" :items="itemFilter" :type="type"></list-view>
  </div>
</template>

<script>
import gridView from "@/components/gridView";
import listView from "@/components/listView";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    gridView,
    listView
  },
  data() {
    return {};
  },
  mounted() {
    this.$dialog;
  },
  computed: {
    ...mapState(["allCases", "allItems", "gridView", "keyWord"]),
    ...mapGetters(["tagNowSelect"]),
    /**
     * @returns {String|Null}  object_id of the case be entered
     */
    nowEnter() {
      let params = this.$route.params;
      let item;
      if (params.caseName) {
        let caseName = params.caseName;
        for (let i in this.allCases) {
          if (this.allCases[i].caseName == caseName) {
            item = this.allCases[i];
          }
        }
      }
      return item.o_id || null;
    },
    /**
     * @returns {String} tagSearch|inCase|doc|graph|all|case|search
     */
    type() {
      let params = this.$route.params;
      if (params.caseName == "tag") {
        return "tagSearch";
      } else if (params.caseName) {
        return "inCase";
      } else if (params.contentType) {
        return params.contentType;
      }
    },
    /**
     * @returns {Array} filtered cases
     */
    caseFilter() {
      switch (this.type) {
        case "doc":
          return this.allCases.filter(v => v.doc !== 0);
        case "graph":
          return this.allCases.filter(v => v.graph !== 0);
        case "all":
          return this.allCases;
        case "case":
          return this.allCases;
        case "inCase":
          return [];
        case "tagSearch":
          return [];
        case "search":
          return this.allCases;
      }
    },
    /**
     * @returns {Array} filtered items
     */
    itemFilter() {
      switch (this.type) {
        case "doc":
          return this.allItems.filter(
            v => v.type == "doc" && !v["case_belong_id"]
          );
        case "graph":
          return this.allItems.filter(
            v => v.type == "graph" && !v["case_belong_id"]
          );
        case "case":
          return [];
        case "all":
          return this.allItems.filter(v => !v["case_belong_id"]);
        case "inCase":
          let firstLevel = this.$curPath()[0];
          return this.allItems.filter(v => {
            if (firstLevel == "doc" || firstLevel == "graph") {
              console.log("firstL:", firstLevel);
              return (
                v["case_belong_id"] == this.nowEnter && v.type == firstLevel
              );
            } else {
              return v["case_belong_id"] == this.nowEnter;
            }
          });
        case "tagSearch":
          return this.allItems.filter(v => {
            for (let i in this.tagNowSelect) {
              let tag = this.tagNowSelect[i];
              if (v.tags && v.tags.includes(tag)) {
                return true;
              }
            }
          });
        case "search":
          return this.allItems;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/page/content.vue